import React from 'react';

export function renderFormattedText(raw: string): React.ReactNode {
  if (!raw) return null;

  // Normalize newlines
  const lines = raw.replace(/\\n/g, '\n').split(/\n+/);

  // Detect if this is a numbered list (e.g., '1. ...', '2. ...')
  const isNumberedList = lines.every(
    (line) => /^\s*\d+\./.test(line.trim()) || !line.trim()
  );

  if (isNumberedList) {
    return (
      <ol className="list-decimal pl-6">
        {lines.filter(Boolean).map((line, idx) => (
          <li key={idx} className="mb-2">
            {line.replace(/^\s*\d+\.\s*/, '')}
          </li>
        ))}
      </ol>
    );
  }

  // Otherwise, render as paragraphs
  return lines.map((line, idx) =>
    line.trim() ? (
      <p key={idx} className="mb-2 last:mb-0">
        {line}
      </p>
    ) : null
  );
}
